<template>
  <div class="modal" id="matrix-modal" v-if="matrixView  || clickedOnVikiInfo">
    <span class="close-img-modal">&times;</span>
    <!--    akg main view-->

    <akg-live-stats
        v-click-outside="closeMatrixView"
        v-if="mainSector === 'MAIN' && subSector === 'AKG'"
        class="modal-content"
    />

    <!--    deposit stats section-->
    <users-deposit-report
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'USERS'"
      class="modal-content"
    />

    <brokers-deposit-report
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'BROKERS'"
      class="modal-content"
    />
    <live-viki-deposits
        v-click-outside="Exit"
        v-if="clickedOnVikiInfo"
        class="modal-content"
    />
<!--    v-if="clickedOnVikiInfo"-->

    <registration-deposit-report
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'DEP_VS_REG'"
      class="modal-content"
    />

    <country-registration-report
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'COUNTRY_REPORT'"
      class="modal-content"
    />

    <deposit-registration-report-chart
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'DEP_REG_CHART'"
      class="modal-content"
    />

    <deposit-v-s-registration-report-chart
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'DEP_VS_REG_CHART'"
      class="modal-content"
    />

    <time-measurement-report
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'TIME_MEASURE_REPORT'"
      class="modal-content"
    />

    <under-perf
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'deposits' && subSector === 'UN_PER'"
      class="modal-content"
    />

    <!--    transfers stats section-->
    <users-transfers-stats
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'transfer' && subSector === 'USERS'"
    />

    <!--    assignments stats section-->
    <total-stats
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'assignments' && subSector === 'ASSIGNMENTS'"
    />
    <total-stats-users
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'assignments' && subSector === 'USERS'"
    />
    <assignment-deposit-report
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'assignments' && subSector === 'AS_VS_DEP'"
    />

    <registration-report
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'assignments' && subSector === 'REG_REPORT'"
    />

    <assignments-stats-table
      v-click-outside="closeMatrixView"
      v-if="mainSector === 'assignments' && subSector === 'ASSIGN_STATS'"
    />
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import UsersDepositReport from "../../../../../statistics.feature/misc.sub_feature/usersDepositReport.stats/containers/UsersDepositReport.container";
import BrokersDepositReport from "../../../../../statistics.feature/misc.sub_feature/brokersDepositReport.stats/containers/BrokersDepositReport.container";
import UsersTransfersStats from "../../../../../statistics.feature/misc.sub_feature/transferRatio.stats/containers/TransferRatio.container";
import TotalStatsUsers from "../../../../../statistics.feature/total_stats_users.sub_feature/containers/TotalStatsUsers.container";
import TotalStats from "../../../../../statistics.feature/total_stats.sub_feature/containers/TotalStats.container";
import AssignmentDepositReport from "../../../../../statistics.feature/misc.sub_feature/assignmentDepositReport.stats/containers/AssignmentDepositReport.container";
import LiveVikiDeposits from "../../../../../statistics.feature/misc.sub_feature/liveVikiDeposits.stats/containers/LiveVikiDeposits.container";
//import LiveVikiCR from "../../../../../statistics.feature/misc.sub_feature/liveVikiCR.stats/containers/liveVikiCR.container";
import RegistrationDepositReport from "../../../../../statistics.feature/misc.sub_feature/registrationDepositReport.stats/containers/RegistrationDepositReport.container";
import RegistrationReport from "../../../../../statistics.feature/misc.sub_feature/registrationReport.stats/containers/RegistrationReport.container";
import CountryRegistrationReport from "../../../../../statistics.feature/misc.sub_feature/countryRegistrationReport.stats/containers/CountryRegistrationReport.container";
import DepositRegistrationReportChart from "../../../../../statistics.feature/misc.sub_feature/depositRegistrationReportChart.stats/containers/DepositRegistrationReportChart.container";
import DepositVSRegistrationReportChart from "../../../../../statistics.feature/misc.sub_feature/depositVSRegistrationReportChart.stats/containers/DepositVSRegistrationReportChart.container";
import TimeMeasurementReport from "../../../../../statistics.feature/misc.sub_feature/timeMeasurementReport.stats/container/TimeMeasurementReport.container";
import UnderPerf from "../../../../../statistics.feature/misc.sub_feature/underPerf.stats/containers/underPerf.container";
import AssignmentsStatsTable from "../../../../../statistics.feature/live_stats.sub_feature/components/AssignmentsStatsTable.component";
import AkgLiveStats from "../../../graph.sub-feature.company/components/AkgLiveStats.component";
import {mapState} from "vuex";


//
//LiveVikiCR,

export default {
  props: {
    matrixView: {
      required: true,
      type: Boolean
    },
    mainSector: {
      required: true,
      type: String
    },
    subSector: {
      required: true,
      type: String
    }
  },
  components: {
    AkgLiveStats,
    UsersDepositReport,
    BrokersDepositReport,
    UsersTransfersStats,
    TotalStatsUsers,
    TotalStats,
    AssignmentDepositReport,
    LiveVikiDeposits,
    RegistrationDepositReport,
    RegistrationReport,
    CountryRegistrationReport,
    DepositRegistrationReportChart,
    DepositVSRegistrationReportChart,
    TimeMeasurementReport,
    UnderPerf,
    AssignmentsStatsTable
  },

  data(){
    return{
      clickedOnVikiInfo: false
    }

  },

  computed: {
    ...mapState("clients", [
     "clickOnViki"
    ]),
  },

  directives: {
    clickOutside: vClickOutside.directive
  },
  name: "MatrixViewComponent",
  mounted() {},
  watch: {
    clickOnViki: function(){
      this.clickedOnVikiInfo = this.clickOnViki;
      this.mainSector = 'deposits';
      this.subSector = 'CR_AGENTS';
    },
    matrixView: function() {
      this.$emit('matrix')
      let span = document.getElementsByClassName("close-img-modal");

      span.onclick = function() {
        this.matrixView = false;
      };
    }
  },
  methods: {
    Exit(){
      this.$store.commit("clients/setClickOnViki",false)
    },
    closeMatrixView() {
      this.matrixView = !!(
        event.target.parentNode &&
        (event.target.parentNode.className === "cell" ||
          event.target.parentNode.className === "cell active" ||
          event.target.parentNode.className === "mx-calendar-header" ||
          event.target.parentNode.className ===
            "mx-btn mx-btn-text mx-btn-icon-right" ||
          event.target.parentNode.className ===
            "mx-btn mx-btn-text mx-btn-icon-left" ||
          event.target.parentNode.className ===
            "mx-btn mx-btn-text mx-btn-icon-double-right" ||
          event.target.parentNode.className ===
            "mx-btn mx-btn-text mx-btn-icon-double-left" ||
          event.target.parentNode.className === "mx-datepicker-body" ||
          event.target.parentNode.className === "" ||
          event.target.parentNode.className === "cell today")
      );
      if(this.subSector === 'COUNTRY_REPORT'){
       this.$store.commit("clients/setReOpenMultiCountry", true);
        // document.getElementsByClassName("close-img-modal");
      }
    }
  }
};
</script>

<style scoped>
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2000; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(184, 184, 184, 0.4); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  /*width: 80%;*/
  /*max-width: 700px;*/
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

span.togglebutton {
  position: absolute;
  left: 0;
  top: 0;
  background-color: black;
  padding: 3px;
  color: white;
  font-size: 50px;
  z-index: 5555555555555555555555555555555555555555;
}
</style>
